module.exports = __webpack_public_path__ + "img/anti-alias.b6db05c0.png";